import Rule from "../../../common/rule";
import { isSeriesOvertime } from "../../utils/overtime-utils";

/**
 * Series overtime: the team the toss names starts on offense, with a new
 * drive; ResetField spots the ball at its overtime starting yardline. A child
 * of CoinToss.
 */
export default class OvertimeOpensWithDrive extends Rule {
    applicable(gameContext) {
        return isSeriesOvertime(gameContext);
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { fragment }) {
        gameContext.setPossessionForTeamId(fragment.settings.offenseTeam.id);
        gameContext.setDriveContext({ triggerDrive: true });
        ruleContext.setResetField(true);
    }
}
